import { isMobile } from './exportFunc';
export default () => {

  const section = document.querySelector('.footer');

  if (!section || !isMobile()) return;
  
  const items = [...document.querySelectorAll('.menu-box')];

  const toggleMenu = el => {
    if (!el) return;

    const menu = el.querySelector('.menu-el__wrapper');

    el.addEventListener('click', () => {
      menu.classList.toggle('menu-el__wrapper--open')
      el.classList.toggle('menu-box--open')
    })
  }

  items.forEach(el => toggleMenu(el))
}